import axios from 'axios';
import type { ClientDetailsInterface } from '../pages/SageAdmin/Clients/Details/types';
import type { ClientListInterface } from '../pages/SageAdmin/Clients/types';
import type { GetCurrentAccountInfoResponse } from '../types/Account';
import type { Invitation } from '../types/ClientOnboardInvitation';
import type { ListTitlesType } from '../types/role';
import { baseUrl, HttpMethods } from './base';

export async function sendInvite(formData: Invitation) {
  const res = await axios.post(`${baseUrl.OS}/accounts/onboard`, formData);
  return res.data;
}

// NOTE: This endpoint needs to be verified - /accounts/info doesn't exist in new backend structure
// TODO: Check if this should use a different endpoint or be removed
export async function getAccountInfo() {
  const res = await axios.get<GetCurrentAccountInfoResponse>(`${baseUrl.SHARED}/accounts/info`);
  return res.data;
}

export async function getClientAccountDetails(accountId: number) {
  const resp = await axios(`${baseUrl.OS}/accounts/${accountId}`);
  return resp.data;
}

export async function updateClientAccountStatus(accountId: number, status: string) {
  const res = await axios.patch(`${baseUrl.OS}/accounts/${accountId}`, {
    status,
  });
  return res.data;
}

export async function changeClientAccountLogo(accountId: number, data: { logoImage: any }) {
  const _res = await axios.patch(`${baseUrl.OS}/accounts/${accountId}`, data);
}

export async function getAccountSubdomain(subdomain: string) {
  const res = await axios.post(`${baseUrl.SHERPA}/accounts/is_available`, {
    subdomain,
  });
  return res.data as {
    data: {
      available: boolean;
    };
  };
}

interface GetClientAccountsService {
  params: IGetTenantsParams;
}

export interface IGetTenantsParams {
  perPage: number;
  page: number;
  status?: 'ACTIVE' | 'SUSPENDED' | 'INVITED';
  subdomain?: string;
}

export interface GetAccountListResponse {
  data: ClientListInterface[];
  meta: { total: number };
}

export async function getAccountList({ params }: Partial<GetClientAccountsService>) {
  const res = await axios.request<GetAccountListResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.OS}/accounts/list`,
    params,
  });
  return res.data;
}

export async function fetchAccountTitles() {
  const res = await axios.get<{
    data: ListTitlesType[];
  }>(`${baseUrl.TERMINAL}/user-management/titles`);
  return res.data;
}

interface UpdateCompanyProfilePayload {
  data: Partial<ClientDetailsInterface>;
  accountId: number;
}
export async function updateCompanyProfile({ accountId, data }: UpdateCompanyProfilePayload) {
  const res = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.OS}/accounts/${accountId}`,
    data,
  });
  return res.data;
}
